import constants from '../services/constants';
import { atom } from 'recoil';

const editTeamAtom = atom<boolean>({
    key: constants.editTeamAtom,
    default: false,
});

export default editTeamAtom;